<template>
  <DealsActionsModal
    :title="title"
    :type="type"
    :description="description"
    :loading="loading"
    @save="handleSave"
    ref="modal"
  >
    <template slot="form">
      <div class="w-100">
        <form>
          <div class="form-group mb-0">
            <label class="observation" for="observation">{{ __('Observações') }}</label>
            <textarea
              id="observation"
              v-model="observation"
              type="text"
              placeholder="Registre aqui suas observações..."
              class="form-control textarea"
              :class="{ 'border-danger': hasErrors }"
              rows="3"
              maxlength="100"
              style="resize: none"
            ></textarea>
            <span v-for="error in errors" class="text-danger mt-1">{{ __(error) }}</span>
          </div>
        </form>
      </div>
    </template>
  </DealsActionsModal>
</template>

<script>
import DealsActionsModal from "../../ActionsModal.vue";

export default {
  name: "DealOpenReasonModal",

  data() {
    return {
      title: this.__("Reabrir negócio"),
      type: "reopen",
      description: this.__("Por favor, informe o motivo no campo abaixo."),
      status: "open",
      deal: null,
      observation: null,
      loading: false,
      errors: [],
    };
  },

  components: {
    DealsActionsModal,
  },

  methods: {
    open(deal) {
      this.resetState();

      this.deal = deal;

      this.$refs.modal.handleOpen();
    },

    resetState() {
      this.deal = null;
      this.observation = null;
      this.loading = false;
      this.errors = [];
    },

    checkErrors() {
      if (!this.observation || this.observation.length < 1) {
        return this.__('*Você deve preencher o campo observações.');
      } else if (this.observation.length > 100) {
        return this.__('*Limite de caracteres excedido.');
      }

      return null;
    },

    handleSave() {
      this.loading = true;

      const error = this.checkErrors();
      if (error) {
        this.loading = false;

        this.errors = [error];

        return;
      }

      this.markAsOpen()
        .then(() => {
          Bus.$emit("closeDealActionModal");
          
          Alert.success(this.__('Negócio reaberto com sucesso!'));

          Bus.$emit('open', this.deal);
        })
        .catch((error) => {
          if (error.status != 422 || !error.body?.observation) {
            console.error(error);
            return Alert.error('Ocorreu um erro inesperado ao reabrir negócio');
          }

          this.errors = error.body.observation;
        }).finally(() => {
          this.loading = false;
        });
    },

    async markAsOpen() {
      return this.$http.put(`/deal/${this.deal.id}`, {
        status: this.status,
        observation: this.observation,
      });
    },
  },

  mounted() {
    Bus.$on("show-open-observation-modal", (deal) => this.open(deal));
  },

  watch: {
    observation() {
      this.errors = [];
    },
  },

  computed: {
    hasErrors() {
      return this.errors?.length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../../sass/variables";

.textarea {
  display: block;
  width: 100%;
  padding: 0.5rem 1rem;
  font-family: Montserrat, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.5;
  color: #3b334a;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 0.5rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border: 1px solid #d1d1d1;
  border-radius: 0.5rem;
}

.textarea:focus {
  color: #3b334a;
  background-color: #fff;
  border-color: #d1d1d1;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(44, 235, 169, 0.25);
}

.observation {
  color: $salesflow-font-dark;
  font-family: Montserrat;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}

.border-danger {
  border: 1px solid #E14E4E;
}
</style>
